import React from "react";
import { DashboardFlexContainer } from "./styled";
import { Loader } from "../../common/styled/loader";

interface DashboardSkeletonProps {
  loading: boolean;
}
const DashboardSkeleton = ({ loading }: DashboardSkeletonProps) => {
  if (loading) {
    return (
      <DashboardFlexContainer>
        <Loader />
      </DashboardFlexContainer>
    );
  }
  return null;
};

export default DashboardSkeleton;
